import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { setImpersonationHandlers } from '@/lib/api'

const IMPERSONATION_TOKEN_KEY = 'sm-impersonation-token'

interface ImpersonationState {
  isImpersonating: boolean
  sessionId: string | null
  targetUserId: string | null
  targetUserName: string | null
  targetUserEmail: string | null
  adminUserId: string | null
  expiresAt: string | null  // ISO string

  startImpersonation: (data: {
    token: string
    sessionId: string
    targetUserId: string
    targetUserName: string
    targetUserEmail: string
    adminUserId: string
    expiresAt: string
  }) => void
  exitImpersonation: () => void
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      isImpersonating: false,
      sessionId: null,
      targetUserId: null,
      targetUserName: null,
      targetUserEmail: null,
      adminUserId: null,
      expiresAt: null,

      startImpersonation: (data) => {
        localStorage.setItem(IMPERSONATION_TOKEN_KEY, data.token)
        set({
          isImpersonating: true,
          sessionId: data.sessionId,
          targetUserId: data.targetUserId,
          targetUserName: data.targetUserName,
          targetUserEmail: data.targetUserEmail,
          adminUserId: data.adminUserId,
          expiresAt: data.expiresAt,
        })
      },

      exitImpersonation: () => {
        localStorage.removeItem(IMPERSONATION_TOKEN_KEY)
        set({
          isImpersonating: false,
          sessionId: null,
          targetUserId: null,
          targetUserName: null,
          targetUserEmail: null,
          adminUserId: null,
          expiresAt: null,
        })
      },
    }),
    {
      name: 'sm-impersonation',
      // Don't persist the raw token — it lives in localStorage separately
      partialize: (s) => ({
        isImpersonating: s.isImpersonating,
        sessionId: s.sessionId,
        targetUserId: s.targetUserId,
        targetUserName: s.targetUserName,
        targetUserEmail: s.targetUserEmail,
        adminUserId: s.adminUserId,
        expiresAt: s.expiresAt,
      }),
    },
  ),
)

// Wire up impersonation handlers to the API client
setImpersonationHandlers(
  () => useImpersonationStore.getState().isImpersonating,
  () => useImpersonationStore.getState().exitImpersonation(),
)
